import React from 'react'
import { getStorageValue, StorageFields } from '../../../../storage/browserStorage'
import { timeLimitToString } from '../../../../util'
import Button from '../../../common/button'
import ChatBubble from '../chatBubble'
import Announcements from './announcements'
import Chat from './chat'
import LastTrick from './lastTrick'
import Players from './players'
import Settings from './settings'

/**
 * @param table
 * @param send
 * @param isOwnTurn
 */
class PlayerMenu extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            shownMenu: undefined,
        }

        this._keyDownListener = evt => {
            if (!this.state.shownMenu && evt && evt.code === "Space" && getStorageValue(StorageFields.ALLOW_CHAT) != "nobody") {
                this.setState({ shownMenu: Menu.CHAT })
            } else if (this.state.shownMenu && evt && evt.code === "Escape") {
                this.setState({ shownMenu: undefined })
            }
        }
        window.addEventListener("keydown", this._keyDownListener)
    }

    componentWillUnmount()
    {
        window.removeEventListener("keydown", this._keyDownListener)
    }

    renderTitleBar()
    {
        return (
            <div key="--title-bar" className="title-bar">
                <div>{ this.getMenuTitle(this.state.shownMenu) }</div>
                <Button
                    text={ Messages("app.back") }
                    onClick={ () => this.setState({ shownMenu: null }) }
                />
            </div>
        )
    }

    getMenuTitle(menu)
    {
        return {
            [Menu.LAST_TRICK]: Messages("table.last-trick"),
            [Menu.ANNOUNCEMENTS]: Messages("table.announcements" + (this.props.table.get("isAnnouncementLastChance") ? ".last-chance" : "")),
            [Menu.SETTINGS]: Messages("table.settings"),
            [Menu.PLAYERS]: Messages("table.players"),
            [Menu.CHAT]: Messages("table.chat")
        }[menu]
    }

    render()
    {
        let t = this.props.table
        let content

        if (!this.state.shownMenu)
        {
            const onTurnBadge = this.props.isOwnTurn ? (
                <div key="turn" className="on-turn-badge">{ Messages("table.on-turn") }</div>
            ) : null
            
            const displayRound = t.get("round") + 1
            const playerCount = t.get("players").size
            const effectivePlayerCount = Math.max(playerCount, 4)
            const handsInRounds = displayRound % effectivePlayerCount ? (displayRound + (effectivePlayerCount - (displayRound % effectivePlayerCount))) : displayRound

            content = [
                <div key="r" className="round-counter">
                    { Messages("table.round", displayRound, handsInRounds) }
                </div>,
                <div key="tl" className="time-limit-info">
                    { timeLimitToString(t.get("timeLimit")) }
                </div>,
                onTurnBadge,
                <Button
                    key="c"
                    disabled={ getStorageValue(StorageFields.ALLOW_CHAT) == "nobody" }
                    text={ this.getMenuTitle(Menu.CHAT) + " (Space)" }
                    onClick={ () => this.setState({ shownMenu: Menu.CHAT }) }
                    style={{ flex: 1, width: "100%", marginBottom: 10 }}
                />,
                <Button
                    key="a"
                    text={ this.getMenuTitle(Menu.ANNOUNCEMENTS) }
                    disabled={ !t.get("possibleAnnouncement") }
                    onClick={ () => this.setState({ shownMenu: Menu.ANNOUNCEMENTS }) }
                    style={{ flex: 1, width: "100%", marginBottom: 10 }}
                />,
                <Button
                    key="l"
                    disabled={ !t.get("lastTrick") }
                    text={ this.getMenuTitle(Menu.LAST_TRICK) }
                    onClick={ () => this.setState({ shownMenu: Menu.LAST_TRICK }) }
                    style={{ flex: 1, marginBottom: 10, width: "100%" }}
                />,
                <div key="btns" className="button-row" style={{ flex: 1, width: "100%" }}>
                    <Button
                        key="p"
                        text={ this.getMenuTitle(Menu.PLAYERS) + " (" + playerCount + ")" }
                        onClick={ () => this.setState({ shownMenu: Menu.PLAYERS }) }
                    />
                    <Button
                        key="s"
                        text={ this.getMenuTitle(Menu.SETTINGS) }
                        onClick={ () => this.setState({ shownMenu: Menu.SETTINGS }) }
                    />
                </div>
            ]
        }
        else if (this.state.shownMenu === Menu.LAST_TRICK)
        {
            content = [
                this.renderTitleBar(Menu.LAST_TRICK),
                <LastTrick
                    table={ t }
                    key="lt"
                />
            ]
        }
        else if (this.state.shownMenu === Menu.ANNOUNCEMENTS)
        {
            content = [
                this.renderTitleBar(Menu.ANNOUNCEMENTS),
                <Announcements
                    table={ t }
                    key="an"
                    send={ this.props.send }
                />
            ]
        }
        else if (this.state.shownMenu === Menu.CHAT)
        {
            content = [
                this.renderTitleBar(Menu.CHAT),
                <Chat
                    table={ t }
                    key="chat"
                    send={ this.props.send }
                    onDone={ () => this.setState({ shownMenu: null }) }
                />
            ]
        }
        else if (this.state.shownMenu === Menu.PLAYERS)
        {
            content = [
                this.renderTitleBar(Menu.PLAYERS),
                <Players
                    table={ t }
                    key="players"
                    send={ this.props.send }
                />
            ]
        }
        else if (this.state.shownMenu === Menu.SETTINGS)
        {
            content = [
                this.renderTitleBar(Menu.SETTINGS),
                <Settings
                    table={ t }
                    key="settings"
                    send={ this.props.send }
                />
            ]
        }

        return (
            <div className={ "player-menu " + (this.state.shownMenu ? "expanded " : "")
                    + (getStorageValue(StorageFields.FADE_MENU) == "true" ? "fade-menu " : "")
                    + (this.props.isOwnTurn ? "own-turn" : "") }>
                { content }
                <ChatBubble
                    players={ t.get("players").filter(p => p.get("turnIdx") == null) }
                    className="general"
                    showAuthor
                    showSystem
                />
            </div>
        )
    }

}

const Menu = {
    CHAT: "chat",
    ANNOUNCEMENTS: "announcements",
    LAST_TRICK: "last-trick",
    PLAYERS: "players",
    SETTINGS: "settings"
}

export default PlayerMenu
export { PlayerMenu }